import AbstractListView from '@UI/Store/AbstractListView';
import type SubjectTypeDefinitionView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectTypeDefinitionView';

/**
 * Immutable View. No local insertion: the screen re-fetches the list after every mutation, so
 * a local edit would only make it lie.
 */
class SubjectTypeDefinitionsListView extends AbstractListView<SubjectTypeDefinitionView> {
	readonly accountId: number;

	constructor(list: readonly SubjectTypeDefinitionView[], accountId: number) {
		super(list, 'SubjectTypeDefinitionsListView');

		this.accountId = accountId;

		Object.freeze(this);
	}
}

export default SubjectTypeDefinitionsListView;
